import {Lightbox} from "../parts/pswp";

export class Gallery {
    private list: HTMLElement;
    private dir: "ltr" | "rtl" | "ttb";
    private trigger: ScrollTrigger | null = null;
    private currentX = 0;
    private stripWidth = 0;
    private originals: HTMLElement[] = [];

    constructor(public gallery: HTMLElement, private carousel: HTMLElement) {
        this.list = this.carousel.querySelector('.gallery-list')!;
        this.init();
    }

    init(): void {
        if (!this.list) return;

        const attrDir = this.carousel.getAttribute('data-dir');
        this.dir = (attrDir === 'rtl' || attrDir === 'ttb') ? attrDir : 'ltr';
        const directionFactor = this.dir === 'rtl' ? -1 : 1;

        if (this.carousel.classList.contains('pswp-gallery')) {
            new Lightbox(this.carousel);
        }

        this.originals = Array.from(this.list.children) as HTMLElement[];
        this.buildClones();

        let lastProgress = -1;

        this.trigger = window.scrollTrigger.create({
            trigger: this.gallery,
            start: 'top bottom',
            end: 'bottom top',
            fastScrollEnd: true,
            onUpdate: (self) => {
                if (lastProgress < 0) {
                    lastProgress = self.progress;
                    return;
                }

                const delta =
                    (lastProgress - self.progress) *
                    window.innerHeight *
                    0.5 *
                    directionFactor;

                this.currentX += delta;
                this.applyTransform();
                lastProgress = self.progress;
            },
        });
    }

    private addCloneSet(): void {
        this.originals.forEach((el) => {
            const clone = el.cloneNode(true) as HTMLElement;
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            this.list.appendChild(clone);
        });
    }

    private buildClones(): void {
        if (!this.originals.length) return;

        this.addCloneSet();

        requestAnimationFrame(() => {
            const firstClone = this.list.querySelector('[aria-hidden="true"]') as HTMLElement | null;
            if (!firstClone) return;

            this.stripWidth =
                firstClone.getBoundingClientRect().left -
                this.originals[0].getBoundingClientRect().left;

            if (this.stripWidth <= 0) return;

            const setsNeeded = Math.ceil(this.carousel.offsetWidth / this.stripWidth) + 1;
            for (let i = 0; i < setsNeeded; i++) {
                this.addCloneSet();
            }
        });
    }

    private applyTransform(): void {
        if (this.stripWidth <= 0) return;

        const x =
            ((this.currentX % this.stripWidth) + this.stripWidth) %
            this.stripWidth -
            this.stripWidth;

        this.list.style.transform = `translateX(${x}px)`;
    }


    destroy(): void {
        this.trigger?.kill();
        this.trigger = null;

        if (this.list) {
            this.list.style.transform = '';
            this.list.querySelectorAll('[aria-hidden="true"]').forEach((el) => el.remove());
        }
    }
}